export default __webpack_public_path__ + "static/media/hideAccord.57650b39.svg";